<template>
  <a-modal
    class="modal-content"
    :title="title"
    :width="650"
    :visible="visible"
    :footer="null"
    @cancel="hideModal"
  >
    <div style="min-height: 300px">
      <div v-html="richText"></div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'DetailContent',
  components: {},
  props: {
    title: {
      type: String,
      default: '查看详情',
    },
  },
  data() {
    return {
      visible: false,
      richText: '',
    }
  },
  methods: {
    showModal(data) {
      this.visible = true
      this.richText = data.content
    },
    hideModal() {
      this.visible = false
    },
  },
}
</script>
<style scoped lang="less">
//.modal-content {
//  /deep/ .ant-modal-body {
//    padding: 10px 24px;
//  }
//}
</style>
